<div class="center pos-relative _upscale-container "
     [sizeClass]="'SM: ratio-1-1-s ratio-2-1-m w-12, XL: flex-grow overflow-hidden'">
    <!-- tools -->
    <div class="flex pos-absolute z-2"
         sizeClass="SM: top-2 left-2 right-2, XL: top-4 left-4 right-4">
        <div class="flex-grow">
            <ng-content select="[topTools]"></ng-content>
        </div>
        @if (canFocus) {
        <button *ifSize="'SM'"
                class="m-l-2 box-shadow-1 bg-col-w col-12 b-radius-max inline-flex"
                [style.padding]="'6px'"
                (click)="focus()">
            <i class="icon-zoom inline-flex _icon m-a-0"
               [class.col-1]="isFocusActive"></i>
            @if (!client.isTouchy) {
            <tooltip [position]="'left'">{{'Focus' | translate}}</tooltip>
            }
        </button>
        }

        <div *ifSize="'XL'"
             class="m-l-2 bg-col-w box-shadow-1 _zoom-tool flex flex-column">
            <button (click)="zoomIn()"
                    class="p-t-1 m-t-1">
                <i class="icon-zoom-in inline-flex _icon"></i>
                @if (!client.isTouchy) {
                <tooltip [position]="'left'">{{'Zoom in' | translate}}</tooltip>
                }
            </button>

            <button (click)="zoomOut()"
                    class="p-t-1"
                    [class.m-b-1]="!canFocus">
                <i class="icon-zoom-out inline-flex _icon"></i>
                @if (!client.isTouchy) {
                <tooltip [position]="'left'">{{'Zoom out' | translate}}</tooltip>
                }
            </button>


            @if (canFocus) {
            <button (click)="focus()"
                    class="p-t-1 m-b-1">
                <i class="icon-zoom inline-flex _icon"
                   [class.col-1]="isFocusActive"></i>
                @if (!client.isTouchy) {
                <tooltip [position]="'left'">{{'Focus' | translate}}</tooltip>
                }
            </button>
            }
        </div>
    </div>

    <ng-content select="[wishlist]"></ng-content>
    <ng-content select="[addToBasket]"></ng-content>


    <!-- Zoom -->
    <div class="_image-section overflow-hidden fill"
         builderZoom
         [builderZoomOff]="!isZoomActive"
         [(zoomScale)]="zoomScale"
         [zoomForcePositionTop]="focusShiftTop"
         [zoomForcePositionLeft]="focusShiftLeft"
         (zoomMoveChange)="resetFocus()">

        <!-- need for prop zoom -->
        <div class="fill _basePosition"
             [style.--base-scale]="basePosition.scale"
             [style.--base-top-shift]="basePosition.posTop + '%'"
             [style.--base-left-shift]="basePosition.posLeft+ '%'">

            <!-- container for batter quality -->
            <div class="_images-container fill"
                 [style.--horse-shift-number]="horseImageData?.shift"
                 [style.--rider-shift-number]="riderImageData?.shift">
                @if (background) {
                <img [attr.draggable]="false"
                     class="fill"
                     [image]="background">
                }

                <!-- Horse images -->
                @if (horseImageData?.image) {
                <img [attr.draggable]="false"
                     class="fill"
                     [class._horse-position]="bothImages"
                     [class.hidden]="(displayAltImage && horseImageData?.altImage)"
                     [image]="horseImageData?.image"
                     [noResize]="true">
                }

                <!-- Horse images -->
                @if (horseImageData?.altImage) {
                <img [attr.draggable]="false"
                     class="fill hidden"
                     [class._horse-position]="bothImages"
                     [class.hidden]="!displayAltImage"
                     [image]="horseImageData?.altImage"
                     [noResize]="true">
                }

                @for (selectionImage of selectionHorseImages; track $index) {
                @if (selectionImage) {
                <img [attr.draggable]="false"
                     class="fill"
                     [image]="selectionImage"
                     [class._horse-position]="bothImages"
                     [noResize]="true">
                }
                }

                <!-- Rider -->
                @if (riderImageData?.image) {
                <img [attr.draggable]="false"
                     class="fill"
                     [image]="riderImageData?.image"
                     [class._rider-position]="bothImages"
                     [class.hidden]="(displayAltImage && riderImageData?.altImage)"
                     [noResize]="true">
                }

                <!-- Rider -->
                @if (riderImageData?.altImage) {
                <img [attr.draggable]="false"
                     class="fill hidden"
                     [image]="riderImageData?.altImage"
                     [class.hidden]="!displayAltImage"
                     [class._rider-position]="bothImages"
                     [noResize]="true">
                }

                @for (selectionImage of selectionRiderImages; track $index) {
                @if (selectionImage) {
                <img [attr.draggable]="false"
                     class="fill"
                     [class._rider-position]="bothImages"
                     [image]="selectionImage"
                     [noResize]="true">
                }
                }
            </div>
        </div>
    </div>
</div>
